{
  "AF": "Afghanistan",
  "EG": "Egypte",
  "AX": "Ålandeilanden",
  "AL": "Albanië",
  "DZ": "Algerije",
  "AS": "Amerikaans-Samoa",
  "VI": "Amerikaanse Maagdeneilanden",
  "UM": "Amerikaanse Overzeese Eilanden",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua en Barbuda",
  "GQ": "Equatoriaal-Guinea",
  "AR": "Argentinië",
  "AM": "Armenië",
  "AW": "Aruba",
  "AC": "Ascension",
  "AZ": "Azerbeidzjan",
  "ET": "Ethiopië",
  "AU": "Australië",
  "BS": "Bahama's",
  "BH": "Bahrein",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Wit-Rusland",
  "BE": "België",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BQ": "Bonaire, Sint Eustatius en Saba",
  "BA": "Bosnië en Herzegovina",
  "BW": "Botswana",
  "BR": "Brazilië",
  "VG": "Britse Maagdeneilanden",
  "IO": "Brits Territorium in de Indische Oceaan",
  "BN": "Brunei Darussalam",
  "BG": "Bulgarije",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "CV": "Kaapverdië",
  "EA": "Ceuta en Melilla",
  "CL": "Chili",
  "CN": "China",
  "CK": "Cookeilanden",
  "CR": "Costa Rica",
  "CI": "Ivoorkust",
  "CW": "Curaçao",
  "DK": "Denemarken",
  "DE": "Duitsland",
  "DG": "Diego Garcia",
  "DM": "Dominica",
  "DO": "Dominicaanse Republiek",
  "DJ": "Djibouti",
  "EC": "Ecuador",
  "SV": "El Salvador",
  "ER": "Eritrea",
  "EE": "Estland",
  "EZ": "Eurozone",
  "FK": "Falklandeilanden",
  "FO": "Faeröer",
  "FJ": "Fiji",
  "FI": "Finland",
  "FR": "Frankrijk",
  "GF": "Frans-Guyana",
  "PF": "Frans-Polynesië",
  "TF": "Franse Zuidelijke en Antarctische Gebieden",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgië",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GD": "Grenada",
  "GR": "Griekenland",
  "GL": "Groenland",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinee",
  "GW": "Guinee-Bissau",
  "GY": "Guyana",
  "HT": "Haïti",
  "HN": "Honduras",
  "IN": "India",
  "ID": "Indonesië",
  "IQ": "Irak",
  "IR": "Iran",
  "IE": "Ierland",
  "IS": "IJsland",
  "IM": "Isle of Man",
  "IL": "Israël",
  "IT": "Italië",
  "JM": "Jamaica",
  "JP": "Japan",
  "YE": "Jemen",
  "JE": "Jersey",
  "JO": "Jordanië",
  "KY": "Kaaimaneilanden",
  "KH": "Cambodja",
  "CM": "Kameroen",
  "CA": "Canada",
  "IC": "Canarische Eilanden",
  "KZ": "Kazachstan",
  "QA": "Qatar",
  "KE": "Kenia",
  "KG": "Kirgizië",
  "KI": "Kiribati",
  "CC": "Cocoseilanden",
  "CO": "Colombia",
  "KM": "Comoren",
  "CG": "Congo-Brazzaville",
  "CD": "Congo-Kinshasa",
  "XK": "Kosovo",
  "HR": "Kroatië",
  "CU": "Cuba",
  "KW": "Koeweit",
  "LA": "Laos",
  "LS": "Lesotho",
  "LV": "Letland",
  "LB": "Libanon",
  "LR": "Liberia",
  "LY": "Libië",
  "LI": "Liechtenstein",
  "LT": "Litouwen",
  "LU": "Luxemburg",
  "MG": "Madagaskar",
  "MW": "Malawi",
  "MY": "Maleisië",
  "MV": "Maldiven",
  "ML": "Mali",
  "MT": "Malta",
  "MA": "Marokko",
  "MH": "Marshalleilanden",
  "MQ": "Martinique",
  "MR": "Mauritanië",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MK": "Macedonië",
  "MX": "Mexico",
  "FM": "Micronesië",
  "MC": "Monaco",
  "MN": "Mongolië",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibië",
  "NR": "Nauru",
  "NP": "Nepal",
  "NC": "Nieuw-Caledonië",
  "NZ": "Nieuw-Zeeland",
  "NI": "Nicaragua",
  "NL": "Nederland",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "KP": "Noord-Korea",
  "MP": "Noordelijke Marianen",
  "NF": "Norfolk",
  "NO": "Noorwegen",
  "OM": "Oman",
  "AT": "Oostenrijk",
  "TL": "Oost-Timor",
  "PK": "Pakistan",
  "PS": "Palestijnse Gebieden",
  "PW": "Palau",
  "PA": "Panama",
  "PG": "Papoea-Nieuw-Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Filipijnen",
  "PN": "Pitcairneilanden",
  "PL": "Polen",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "MD": "Moldavië",
  "RE": "Réunion",
  "RW": "Rwanda",
  "RO": "Roemenië",
  "RU": "Rusland",
  "SB": "Salomonseilanden",
  "ZM": "Zambia",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Sao Tomé en Principe",
  "SA": "Saoedi-Arabië",
  "SE": "Zweden",
  "CH": "Zwitserland",
  "SN": "Senegal",
  "RS": "Servië",
  "SC": "Seychellen",
  "SL": "Sierra Leone",
  "ZW": "Zimbabwe",
  "SG": "Singapore",
  "SX": "Sint Maarten",
  "SK": "Slowakije",
  "SI": "Slovenië",
  "SO": "Somalië",
  "MO": "Speciale Bestuurlijke Regio Macau",
  "HK": "Speciale Bestuurlijke Regio Hongkong",
  "ES": "Spanje",
  "SJ": "Spitsbergen",
  "LK": "Sri Lanka",
  "BL": "Saint Barthélemy",
  "SH": "Sint-Helena",
  "KN": "Saint Kitts en Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre en Miquelon",
  "VC": "Saint Vincent en de Grenadines",
  "ZA": "Zuid-Afrika",
  "SD": "Soedan",
  "GS": "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  "KR": "Zuid-Korea",
  "SS": "Zuid-Soedan",
  "SR": "Suriname",
  "SZ": "Swaziland",
  "SY": "Syrië",
  "TJ": "Tadzjikistan",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "TH": "Thailand",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad en Tobago",
  "TA": "Tristan da Cunha",
  "TD": "Tsjaad",
  "CZ": "Tsjechië",
  "TN": "Tunesië",
  "TR": "Turkije",
  "TM": "Turkmenistan",
  "TC": "Turks- en Caicoseilanden",
  "TV": "Tuvalu",
  "UG": "Oeganda",
  "UA": "Oekraïne",
  "HU": "Hongarije",
  "UY": "Uruguay",
  "UZ": "Oezbekistan",
  "VU": "Vanuatu",
  "VA": "Vaticaanstad",
  "VE": "Venezuela",
  "AE": "Verenigde Arabische Emiraten",
  "US": "Verenigde Staten",
  "GB": "Verenigd Koninkrijk",
  "UN": "Verenigde Naties",
  "VN": "Vietnam",
  "WF": "Wallis en Futuna",
  "CX": "Christmaseiland",
  "EH": "Westelijke Sahara",
  "CF": "Centraal-Afrikaanse Republiek",
  "CY": "Cyprus"
}
